import { createContext, useContext, useMemo } from 'react';
import localizers from '../i18n_js/messages';
import loadingTextLocalizers from '../i18n_js/loadingText';
const defaultContext = { localizers, loadingTextLocalizers };
const I18nContext = createContext(defaultContext);
I18nContext.displayName = 'I18nContext';
export const I18nProvider = I18nContext.Provider;
export function useI18n(localeKey) {
    const localizers = useContext(I18nContext).localizers;
    return useMemo(() => {
        if (localeKey === undefined) {
            return (key) => extractLocalizedText(key, localizers);
        }
        return extractLocalizedText(localeKey, localizers);
    }, [localizers, localeKey]);
}
export function useLoadingText() {
    const localizers = useContext(I18nContext).loadingTextLocalizers;
    return useMemo(() => localizers['loading.msg'](), [localizers]);
}
export function useEmbeddedI18n(localeKey) {
    const localizers = useContext(I18nContext).loadingTextLocalizers;
    return useMemo(() => {
        if (localeKey === undefined) {
            return (key) => extractLocalizedText(key, localizers);
        }
        return extractLocalizedText(localeKey, localizers);
    }, [localizers, localeKey]);
}
function extractLocalizedText(localeKey, localizers) {
    if (typeof localeKey === 'string') {
        return localeKey;
    }
    if (!localizers[localeKey.key]) {
        // Someone has bypassed the type system to give us a key that is not translated.  Just return the key.
        // TODO - Log a warning
        return localeKey.key;
    }
    return localeKey.args ? localizers[localeKey.key](localeKey.args) : localizers[localeKey.key]();
}
